import { useQuery } from '@tanstack/react-query';
import { useSelector } from 'react-redux';

import { makeAPIRequestReactQuery } from './api';
import { endpoints } from './endpoints';

export const usePmsClinicalNotes = ({
  patientId,
  apptDate,
}: {
  patientId: number;
  apptDate: Date;
}) => {
  const { primaryOrganizationId: orgId } = useSelector(
    (state: any) => state.login.user,
  );

  const pmsClinicalNotesPath = `${endpoints.pmsClinicalNotes}`;

  return useQuery(
    [pmsClinicalNotesPath, orgId, patientId, apptDate],
    () =>
      makeAPIRequestReactQuery<{ data: TPmsClinicalNote[] }>(
        pmsClinicalNotesPath,
        {
          patientId: patientId,
          appointmentDate: new Date(apptDate).toISOString(),
        },
        'get',
        {
          headers: {
            Org: orgId,
          },
        },
      ),
    {
      enabled: !!patientId && !!apptDate,
    },
  );
};

export type TPmsClinicalNote = {
  note?: string;
  noteDate: Date;
  videaId: string;
  id: string;
  providerId: string;
  patientId: string;
};
